/**
 * Constant values for Markdown Parser
 */
/**
 * List plugin events
 * @hidden
 */
export var LISTS_COMMAND = 'lists-commands';
/**
 * selectioncommand plugin events
 * @hidden
 */
export var selectionCommand = 'command-type';
/**
 * Link plugin events
 * @hidden
 */
export var LINK_COMMAND = 'link-commands';
/**
 * Clear plugin events
 * @hidden
 */
export var CLEAR_COMMAND = 'clear-commands';
/**
 * Table plugin events
 * @hidden
 */
export var MD_TABLE = 'insert-table';
